import { LitElement, html, css } from 'lit';
import {customElement, property} from 'lit/decorators.js'
import GridCSS from './styles/grid'
import '@shoelace-style/shoelace/dist/components/button/button';
import './vxc_input'
import './vxc_select'
import './vxc_input_tags'
import { TInput } from './vxc_input';
import { TInputTags } from './vxc_input_tags';

@customElement('vxc-websrc-editor')

class TWebSourceEditor extends LitElement {
  static styles = [
    GridCSS,
    css`
        :host {
            width: 100%;
            font-family: 'Poppins', sans-serif;
            background-color: #f6f9ff;
        }

        h1 {
            font-size: 1.1rem;
        }

        .container {
            background-color: white;
            overflow: auto;
        }

        .button-set {
            display: flex; 
            justify-content: flex-end; 
            gap: 1rem;
            margin: 1rem 2rem;
        }
    `]

    @property({ type: String, attribute: 'domain'  })      domain : string = ''
    @property({ type: Array,  attribute: 'include' })      include: Array<string> = []
    @property({ type: Array,  attribute: 'exclude' })      exclude: Array<string> = []

    private domainUpdated(event: Event) {
        const input = event.target as TInput
        this.domain = input.value
        this.dispatchEvent(new CustomEvent('domain-updated', { detail: { value: this.domain } }));
    }

    private includeUpdated(event: Event) {
        const input = event.target as TInputTags
        this.include = input.value
        this.dispatchEvent(new CustomEvent('include-updated', { detail: { value: this.include } }));
    }

    private excludeUpdated(event: Event) {
        const input = event.target as TInputTags
        this.exclude = input.value
        this.dispatchEvent(new CustomEvent('exclude-updated', { detail: { value: this.exclude } }));
    }


    render() {
        return html`
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <vxc-input 
                            title="Domain Name" 
                            label="enter the domain name of your website."
                            placeholder="domain.com"
                            value=${this.domain}
                            @input=${this.domainUpdated}
                        ></vxc-input>
                    </div>
                </div>                                                                             

                <div class="row">
                    <div class="col col-md-6 flex-col">
                        <vxc-input-tags
                            title="Included URL(s)"
                            description="leave empty to include all urls.."
                            value=${JSON.stringify(this.include||[])}
                            @input=${JSON.stringify(this.includeUpdated)}
                        ></vxc-input-tags>
                    </div>
                    <div class="col col-md-6 flex-col">
                        <vxc-input-tags
                            title="Excluded URL(s)"
                            description="leave empty for no url to be excluded.."
                            value=${JSON.stringify(this.exclude||[])}
                            @input=${JSON.stringify(this.excludeUpdated)}
                        ></vxc-input-tags>
                    </div>
                </div>
            </div>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-websrc-editor': TWebSourceEditor;
  }
}